/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { MsalInterceptorConfiguration } from '@azure/msal-angular/msal.interceptor.config';

function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log('MSAL Angular: ', message);
}

fetch('/app-config/app-config.json')
  .then(response => response.json())
  .then(json => {
    platformBrowserDynamic([
      {
        provide: MSAL_INSTANCE,
        useValue: new PublicClientApplication({
          auth: {
            clientId: json.msalConfig.clientId,
            authority: json.msalConfig.authority,
            redirectUri: '/',
            knownAuthorities: json.msalConfig.knownAuthorities,
            OIDCOptions: json.msalConfig.OIDCOptions,
          },
          cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: true, // set to true for IE 11,
          },
          system: {
            loggerOptions: {
              loggerCallback,
              logLevel: LogLevel.Info,
              piiLoggingEnabled: false,
            },
          },
        }),
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useValue: {
          interactionType: InteractionType.Redirect,
        } as MsalGuardConfiguration,
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useValue: {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map(
            json.msalConfig.interceptor.protectedResourceMap
          ),
        } as MsalInterceptorConfiguration,
      },
    ])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
